<script setup lang="ts">
import { useHead } from '@unhead/vue';
import bannerUrl from '../../img/stone-henge.png';

useHead({
  title: 'UK Touhou Community',
  meta: [
    { name: 'description', content: 'The web hub for the Touhou fanbase in the UK!' },
  ]
});

</script>

<template>
  <main class="fullscreen-page" :style="`background-image: url(${bannerUrl})`">
    <div class="overlay-content">
      <div class="content-container">
        <h1 class="page-heading tagline">Welcome to the UK Touhou community!</h1>

        <router-link to="/events" class="hero-button events-button">
          <span class="button-icon">🗓️</span>
          <span>View Events</span>
        </router-link>

        <a class="hero-button discord-button" v-discord-invite>
          <img src="../../img/Discord-Symbol-White.svg" alt="Discord Logo">
          <span>Join Discord</span>
        </a>

        <img class="qr-code" src="../../img/discord-invite.png" alt="Discord QR Code">
        <p class="qr-text">...or show the friend you just met this QR code to join (useful at conventions)</p>
      </div>
    </div>
  </main>
</template>

<style scoped>
.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: min(450px, 100vw);
  display: flex;
  align-items: center;
  overflow-y: auto;
}

.content-container {
  background: rgba(0, 0, 0, 0.6);
  padding: var(--space-4xl) var(--space-2xl) var(--space-4xl) var(--space-3xl);
  margin: auto 0;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
}

.tagline {
  margin: 0 0 var(--space-md) 0;
}


.qr-code {
  width: 140px;
  height: 140px;
  background: rgba(255, 255, 255, 0.1);
  padding: var(--space-sm);
  margin-top: var(--space-md);
  box-sizing: border-box;
}

.qr-text {
  font-family: var(--font-display);
  font-size: var(--font-size-md);
  color: var(--color-text-white-80);
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
